import React from "react";
import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";
import axios from "axios";

export default function UserDropdown() {

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post('https://api.tbh.social/admin/logout', {}, {
        withCredentials: true  // ✅ cookie clear karva
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    navigate('/login');
  };

  return (
    <div className="relative">
      
        <Button className="p-3 rounded-lg text-white py-2 d- align-items-center bg-[#EC2178]" onClick={handleLogout}>
          <div className='logout-icon ps-1'></div>
          Logout
        </Button>
    </div>
  );
}
